import { QBankStructureStatus } from '@exam-management/graphql';

import { QBankStructureLevelItemFormAction } from '../../constants';

export enum QBankStructureLevelItemRowWithActionState {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  LOCK = 'LOCK',
}

export function getRowItemState(
  action: QBankStructureLevelItemFormAction,
  status: QBankStructureStatus,
) {
  if (status === QBankStructureStatus.Draft) {
    return QBankStructureLevelItemRowWithActionState.EDIT;
  }
  if ([QBankStructureStatus.Published, QBankStructureStatus.Archived].includes(status)) {
    return QBankStructureLevelItemRowWithActionState.VIEW;
  }

  if (action === QBankStructureLevelItemFormAction.EDIT) {
    return QBankStructureLevelItemRowWithActionState.EDIT;
  }

  return QBankStructureLevelItemRowWithActionState.VIEW;
}

export function getEndAdornmentState(
  isDraft: boolean,
  isNew: boolean,
  isEditable: boolean,
  rowItemState: QBankStructureLevelItemRowWithActionState,
  isFirstLevel: boolean,
) {
  if (isFirstLevel) return QBankStructureLevelItemRowWithActionState.VIEW;
  if (isDraft) return QBankStructureLevelItemRowWithActionState.EDIT;
  if (!isNew && isEditable) return QBankStructureLevelItemRowWithActionState.LOCK;
  return rowItemState;
}

export function getStartAdornmentState(
  isDraft: boolean,
  isNew: boolean,
  isEditable: boolean,
  rowItemState: QBankStructureLevelItemRowWithActionState,
  isFirstLevel: boolean,
) {
  // First level is considered as always in view state
  if (isFirstLevel) return QBankStructureLevelItemRowWithActionState.VIEW;

  // Draft status is considered as always allow to edit except first level
  if (isDraft) return QBankStructureLevelItemRowWithActionState.EDIT;

  // Other status is considered as lock state when not new and editable
  if (!isNew && isEditable) return QBankStructureLevelItemRowWithActionState.LOCK;

  return rowItemState;
}

export function getConvertibleToNonInfo(
  isNew: boolean,
  isNonInfoLevelItem: boolean,
  isFirstLevel: boolean,
  isLastLevel: boolean,
  isDraft: boolean,
  hasNonInfoLevelItemInLevel: boolean,
) {
  // Draft status is considered as always allow to convert to non info except
  // - Does not have Non-info level item in the level
  // - First level
  // - Last level
  if (isDraft) {
    return !hasNonInfoLevelItemInLevel && !isLastLevel && !isFirstLevel;
  }
  // Other status is considered as editable when New Item which is
  // - Not Non-info level item and Not Last level
  return isNew && !isNonInfoLevelItem && !hasNonInfoLevelItemInLevel && !isLastLevel;
}

export function getEditableInput(
  isNew: boolean,
  isEditable: boolean,
  isNonInfoLevelItem: boolean,
  isDraft: boolean,
  isFirstLevel: boolean,
) {
  // Draft status is considered as always allow to edit except first level
  if (isDraft) {
    return !isFirstLevel;
  }

  // Other status is considered as editable when
  // - Editable and is non info level item
  // or
  // - New item
  return isEditable && !isNonInfoLevelItem && isNew;
}

export function getIsChildAddable(
  status: QBankStructureStatus,
  isLastLevel: boolean,
  isEditingList: boolean,
) {
  switch (status) {
    case QBankStructureStatus.Draft:
    case QBankStructureStatus.Published:
    case QBankStructureStatus.Unpublished:
      return !isLastLevel && isEditingList;
    case QBankStructureStatus.Archived:
    default:
      return false;
  }
}
